import React from 'react'

import { connect } from 'react-redux'
import {
  Route,
  Redirect
} from 'react-router-dom'

const PrivateRoute = ({user, component: Component, ...rest}) =>
  <Route {...rest} render={props => {
    if (user.name) {
      return <Component {...props} />
    }

    return <Redirect to={{
      state: { from: props.location },
      pathname: '/login'
    }} />
  }} />

const mapStateToProps = ({auth: { user }}) => ({ user })
export default connect(mapStateToProps)(PrivateRoute)



// WEBPACK FOOTER //
// ./src/login/PrivateRoute.js